import { render, staticRenderFns } from "./success.vue?vue&type=template&id=209c72a8&scoped=true&lang=pug"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c72a8",
  null
  
)

export default component.exports